module.exports = __webpack_public_path__ + "static/media/test9_1.e3bc3172.png";